"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var styles = {
  "tooltip-content": "TooltipContent__tooltip-content__2VJ2d",
  "tooltipContent": "TooltipContent__tooltip-content__2VJ2d"
}; 
require('./TooltipContent.css');
var TooltipContent = function TooltipContent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltipContent
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: "info-oauth-tooltip-text"
  }, "Provide comma-separated list of redirect URIs for your application to use as an oAuth 2.0 client"));
};
var _default = exports.default = TooltipContent;
//# sourceMappingURL=TooltipContent.js.map